import { registerApplication, start } from "single-spa";
import {
  constructApplications,
  constructRoutes,
  constructLayoutEngine,
} from "single-spa-layout";
import { HTMLLayoutData } from "single-spa-layout/dist/types/isomorphic/constructRoutes";
import microfrontendLayout from "./microfrontend-layout.html";
import "./index.css";
import "./tokens.css";
import { theme } from "./theme";
import { ProfileService } from "./services/profile";
import { ReplaySubject } from "rxjs";
import { watchInactivityTime } from "./services/inactivityService";

const profileEventEmitter = new ReplaySubject<ProfileService>(1);
const profile = new ProfileService(profileEventEmitter);

window.addEventListener("single-spa:before-routing-event", (evt) => {
  if (profile.isLogged && profile.isPasswordResetRequired && ((evt as any)?.detail?.newUrl as string)?.endsWith("#/profile/password") != true) {
    window.location.href = "#/profile/password";
  }
});

profile.loadSession();

(window as any).courierPortal = {
  profile,
};

const recaptchaSiteKey = (document.getElementById("recaptchaSiteKey") as HTMLInputElement)?.value;
(window as any).validateCaptcha = function (action: string) {
  return new Promise((res, rej) => {
    (window as any).grecaptcha.enterprise.ready(() => {
      (window as any).grecaptcha.enterprise.execute(recaptchaSiteKey, { action }).then((token: string) => {
        return res(token);
      })
    })
  })
}

watchInactivityTime(profile);

profileEventEmitter.next(profile);

const data: HTMLLayoutData = {
  loaders: {
    mainContentLoader: "<div>Trwa ładowanie zasobu...</div>",
  },
  props: {
    theme: theme,
    // createGlobalStyle: createGlobalStyle,
    profile: profileEventEmitter,
  },
  errors: {
    mainContentError: "<div>Nie udało się załadować komponentu</div>",
  },
};

const routes = constructRoutes(microfrontendLayout, data);
const applications = constructApplications({
  routes,
  loadApp({ name }) {
    return System.import(name);
  },
});
const layoutEngine = constructLayoutEngine({ routes, applications });

applications.forEach(registerApplication);
layoutEngine.activate();
start();

